import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  contasProjeto: function (idProjeto) {
    return Vue.http.get(`/api/projetos/${idProjeto}/contasProjeto`).then(response => response.data);
  },
  informacoes: idProjeto => {
    return Vue.http.get(`/api/projetos/${idProjeto}/InformacoesProjeto`)
      .then(response => response.data);
  },
  listaDeProjetos: function () {
    return Vue.http.get('/api/projetos/projetos').then(response => response.data);
  },
  listaDeProjetosPermissao: function (permissao) {
    return Vue.http.get(`/api/projetos/projetos/${permissao}`).then(response => response.data);
  },
  listaDeProjetosPermissaoAcessoEspecial: function () {
    return Vue.http.get(`/api/projetos/acessoespecial`).then(response => response.data);
  },
  listaTodosProjetos: function () {
    return Vue.http.get('/api/projetos/listaProjetos').then(response => response.data);
  },
  listaProjetosCoordVice: function () {
    return Vue.http.get('/api/projetos/listaProjetosCoordVice').then(response => response.data);
  },
  listaProjetosRelatorioTecnico: function () {
    return Vue.http.get('/api/projetos/listaProjetosRelatorioTecnico').then(response => response.data);
  },
  listaProjetosAtendimento: function () {
    return Vue.http.get('/api/projetos/listaProjetosAtendimento').then(response => response.data);
  },
  metaEtapasProjeto: function (idProjeto) {
    if (!idProjeto) return Promise.resolve([]);
    return Vue.http.get(`/api/projetos/${idProjeto}/metaetapasProjeto`).then(response => response.data);
  },
  rubricasProjeto: function (idProjeto, idMetaEtapa) {
    if (!idProjeto) return Promise.resolve([]);
    return Vue.http.get(`/api/projetos/${idProjeto}/rubricasProjeto${'/' + (idMetaEtapa || '')}`)
      .then(response => response.data);
  },
  subrubricasProjeto: function (idProjeto, idRubrica, idMetaEtapa) {
    if (!idProjeto) return Promise.resolve([]);
    return Vue.http.get(`/api/projetos/${idProjeto}/subrubricasProjeto${idRubrica ? `/${idRubrica}` : ''}${idMetaEtapa ? `/${idMetaEtapa}` : ''}`)
      .then(response => response.data);
  },
  rubricasProjetoAcessoEspecial: function (idProjeto, idMetaEtapa) {
    if (!idProjeto) return Promise.resolve([]);
    return Vue.http.get(`/api/projetos/${idProjeto}/acessoespecial/rubricasProjeto${'/' + (idMetaEtapa || '')}`)
      .then(response => response.data);
  },
  subrubricasProjetoAcessoEspecial: function (idProjeto, idRubrica, idMetaEtapa) {
    if (!idProjeto) return Promise.resolve([]);
    return Vue.http.get(`/api/projetos/${idProjeto}/acessoespecial/subrubricasProjeto${idRubrica ? `/${idRubrica}` : ''}${idMetaEtapa ? `/${idMetaEtapa}` : ''}`)
      .then(response => response.data);
  },
  listaDeGrupos: function () {
    return Vue.http.get('/api/projetos/listaGrupos').then(response => response.data);
  },
  listaRubricasLancamento: function (idProjeto) {
    return Vue.http.get(`/api/projetos/${idProjeto}/ListaRubricasLancamentos`)
      .then(response => response.data);
  },
  listaSubRubricasLancamento: function (idProjeto, idRubrica) {
    return Vue.http.get(`/api/projetos/${idProjeto}/ListaSubRubricasLancamentos/${idRubrica}`)
      .then(response => response.data);
  },





  // Deletar sem criptografia.
  lista: function (permissao) {
    return Vue.http.get(`/api/projetos/${permissao}`).then(response => response.data);
  },
  listaDeAcessos: function () {
    return Vue.http.get('/api/projetos').then(response => response.data);
  },
  contas: function (idProjeto) {
    return Vue.http.get(`/api/projetos/${idProjeto}/contas`).then(response => response.data);
  },
  metaEtapas: function (idProjeto) {
    return Vue.http.get(`/api/projetos/${idProjeto}/metaetapas`).then(response => response.data);
  },
  rubricas: function (idProjeto, idMetaEtapa) {
    return Vue.http.get(`/api/projetos/${idProjeto}/rubricas${'/' + (idMetaEtapa || '')}`)
      .then(response => response.data);
  },
  subrubricas: function (idProjeto, idRubrica, idMetaEtapa) {
    return Vue.http.get(`/api/projetos/${idProjeto}/subrubricas${idRubrica ? `/${idRubrica}` : ''}${idMetaEtapa ? `/${idMetaEtapa}` : ''}`)
      .then(response => response.data);
  },
  //




  localEntrega: function (idProjeto) {
    return Vue.http.get(`/api/projetos/${idProjeto}/localentrega`).then(response => response.data);
  },  
  
  //TODO: Verificar possibilidade de remoção
  //Não está sendo utilizado
  listaTransparencia: (idCoordenador, idOrgaoFinanciador, objeto) => {
    return Vue.http.get('/api/projetos/transparencia', {
      params: {idCoordenador, idOrgaoFinanciador, objeto}
    })
      .then(response => response.data);
  },
  //utilizado na transparência - movido para '~modulos/transparencia/servico.js'
  relatorioTransparencia: (pagina, idCoordenador, idOrgaoFinanciador, tituloProjeto) => {
    return Vue.http.get('/api/projetos/RelatorioTransparencia', {
      params: {
        pagina,
        idCoordenador, 
        idOrgaoFinanciador,
        tituloProjeto
      }
    })
      .then(response => response.data);
  },
  //utilizado na transparência - movido para '~modulos/transparencia/servico.js'
  coordenadores: () => {
    return Vue.http.get('/api/projetos/coordenadores')
      .then(response => response.data);
  },
  //utilizado na transparência - movido para '~modulos/transparencia/servico.js'
  orgaosFinaciadores: () => {
    return Vue.http.get('/api/projetos/OrgaosFinaciadores')
      .then(response => response.data);
  },
  //utilizado na transparência - movido para '~modulos/transparencia/servico.js'
  informacaoProjeto: idProjeto => {
    return Vue.http.get(`/api/projetos/${idProjeto}/InformacaoTransparencia`)
      .then(response => response.data);
  },
  
  pertenceEquipe: (idProjeto, cpf) => {
    return Vue.http.get(`/api/projetos/${idProjeto}/PertenceEquipe/${cpf}`)
      .then(response => response.data);
  },
  valoresDiaria: idProjeto => {
    return Vue.http.get(`/api/projetos/${idProjeto}/ValoresDiaria`)
      .then(response => response.data);
  },
  rubricasAdiantamento: function (idProjeto, idMetaEtapa) {
    return Vue.http.get(`/api/projetos/${idProjeto}/RubricasAdiantamento${'/' + (idMetaEtapa || '')}`)
      .then(response => response.data);
  },
  subrubricasAdiantamento: function (idProjeto, idRubrica, idMetaEtapa) {
    return Vue.http.get(`/api/projetos/${idProjeto}/SubrubricasAdiantamento${idRubrica ? `/${idRubrica}` : ''}${idMetaEtapa ? `/${idMetaEtapa}` : ''}`)
      .then(response => response.data);
  },
  rubricasTransferencia: function (idProjeto, idMetaEtapa, creditodebito) {
    return Vue.http.get(`/api/projetos/${idProjeto}/RubricasTransferencia${'/' + (idMetaEtapa || '')}`, {
      params: {
        creditodebito
      }
    })
      .then(response => response.data);
  },
  subrubricasTransferencia: function (idProjeto, idRubrica, idMetaEtapa, creditodebito) {
    return Vue.http.get(`/api/projetos/${idProjeto}/SubrubricasTransferencia${idRubrica ? `/${idRubrica}` : ''}${idMetaEtapa ? `/${idMetaEtapa}` : ''}`, {
      params: {
        creditodebito
      }
    })
      .then(response => response.data);
  },
  orgaoFinanciador: function (idProjeto) {
    return Vue.http.get(`/api/projetos/${idProjeto}/orgaofinanciador`).then(response => response.data);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/projeto/servico.js